import { render, staticRenderFns } from "./unReceivedRmaTCPD.vue?vue&type=template&id=6e47a6d8&scoped=true"
import script from "./unReceivedRmaTCPD.vue?vue&type=script&lang=js"
export * from "./unReceivedRmaTCPD.vue?vue&type=script&lang=js"
import style0 from "./unReceivedRmaTCPD.vue?vue&type=style&index=0&id=6e47a6d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e47a6d8",
  null
  
)

export default component.exports